export const avatarOptions = [
  'https://images.unsplash.com/photo-1535713875002-d1d0cf377fde?w=150',
  'https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=150',
  'https://images.unsplash.com/photo-1527980965255-d3b416303d12?w=150',
  'https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=150',
  'https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=150',
  'https://images.unsplash.com/photo-1544725176-7c40e5a71c5e?w=150',
  'https://images.unsplash.com/photo-1546539782-6fc531453083?w=150',
  'https://images.unsplash.com/photo-1546539782-6fc531453083?w=150',
  'https://images.unsplash.com/photo-1570295999919-56ceb5ecca61?w=150'
]; 